// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"310":"e3279056","993":"d585c3b4"}[chunkId] + ".css";
};